export default class TaskActionsController {
  constructor($element, $document, $scope, ngDialog, Task) {
    'ngInject';

    this.element = $element[0];
    this.$document = $document;
    this.$scope = $scope;
    this.ngDialog = ngDialog;
    this.Task = Task;
  }

  $postLink() {
    this.handleHidding();
  }

  handleHidding() {
    const clickEvent = 'click';
    this.$document.on(clickEvent, (event) => {
      if (!this.opened) {
        return;
      }

      if (event.target === this.element || this.element.contains(event.target)) {
        return;
      }
      this.opened = false;
      this.$scope.$apply();
    });
  }

  handleAction(actionName) {
    this.opened = false;
    const self = this;
    const template = `<${actionName}-modal class="base-modal base-modal--${actionName}"
                                           task="$ctrl.task"
                                           on-action-submit="$ctrl.onActionSubmit(task)"
                                           close-modal="closeThisDialog(value)">
                      </${actionName}-modal>`;
    this.ngDialog.open({
      template,
      plain: true,
      controller: function() {
        this.task = self.task;
        this.onActionSubmit = self.onActionSubmit;
      },
      controllerAs: '$ctrl',
    });
  }

  onActionSubmit(task) {
    this.task.human_state_name = task.human_state_name;
    this.task.actions = task.actions;
    return this.task;
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/components/task-actions-menu/task-actions-menu.controller.js